import { getCourseGroups, getSubCourses } from 'api/shortlisterApi';

export const SET_COURSE_MAP = 'SET_COURSE_MAP';
export const SET_COURSE_MAP_LOADING = 'SET_COURSE_MAP_LOADING';
export const SET_COURSE_MAP_ERROR = 'SET_COURSE_MAP_ERROR';

export const setCourseMap = map => ({
  type: SET_COURSE_MAP,
  payload: map,
});

export const setCourseMapLoading = loading => ({
  type: SET_COURSE_MAP_LOADING,
  payload: loading,
});

export const setCourseMapError = error => ({
  type: SET_COURSE_MAP_ERROR,
  payload: error,
});

export const fetchCourseMap = degree => async dispatch => {
  dispatch(setCourseMapLoading(true));
  console.log("LOADING");
  try {
    const courseGroupsResponse = await getCourseGroups(degree ?? null);
    const courseGroups = courseGroupsResponse.data[0];

    let newCourseMap = {};

    for (const group of courseGroups) {
      const levelName = group.step_1;
      const subCoursesResponse = await getSubCourses(levelName, degree ?? null);
      const subCategories = subCoursesResponse.data[0].map(
        group => `${group.step_2_emoji} ${group.step_2}`
      );
      newCourseMap[`${group.step_1_emoji} ${group.step_1}`] = subCategories;
    }

    dispatch(setCourseMap(newCourseMap));
  } catch (error) {
    console.error('Error fetching course map:', error);
    dispatch(setCourseMapError(error));
  } finally {
    dispatch(setCourseMapLoading(false));
  }
};
